import Footer from "../components/Footer";
import Navbar from "../components/Navbar";

function About() {
  return (
    <div
      className="bg-blue w-full h-full lg:px-16 px-7 overflow-x-hidden font-poor-story text-white lg:text-2xl md:text-lg text-base leading-loose tracking-widest"
      data-aos="fade-right"
      data-aos-easing="ease-in-sine"
      data-aos-duration="400">
      {/* NAVBAR */}
      <Navbar
        pageTitle="About"
        data-aos="fade-right"
        data-aos-easing="ease-in-sine"
        data-aos-duration="500"
      />

      {/* DESCRIPTION */}
      <div
        className=" mt-10"
        data-aos="fade-right"
        data-aos-easing="ease-in-sine"
        data-aos-duration="600">
        <p>
          A Junior Frontend Developer who finds joy in crafting captivating and
          responsive user interfaces. <br />
          With a deep appreciation for design aesthetics and a keen eye for
          details, I specialize in translating visual concepts into interactive
          web experiences. <br />
          I'm dedicated to creating user-friendly interfaces that adapt
          beautifully across devices. <br />
          My passion for creating pixel-perfect, responsive UIs drives me to
          continuously learn and apply the latest web technologies. <br />
          As a junior developer, I'm excited to contribute my skills to creating
          engaging digital solutions that leave a positive impact.
        </p>
      </div>

      {/*PERSONAL DETAILS */}
      <div
        className="grid mt-20"
        data-aos="fade-right"
        data-aos-easing="ease-in-sine"
        data-aos-duration="700">
        <h1 className="text-3xl my-9">Personal Details</h1>
        <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-6">
          <div className="flex items-center">
            <img
              src={require("../assets/icons/circle.png")}
              alt="circle icon"
              className="w-7 inline-block mr-2"
            />
            <span>
              <em>Name:</em> Fatma Alzhraa Mohamed
            </span>
          </div>
          <div className="flex items-center">
            <img
              src={require("../assets/icons/circle.png")}
              alt="circle icon"
              className="w-7 inline-block mr-2"
            />
            <span>
              <em>Birth:</em> Jan 2000
            </span>
          </div>
          <div className="flex items-center">
            <img
              src={require("../assets/icons/circle.png")}
              alt="circle icon"
              className="w-7 inline-block mr-2"
            />
            <span>
              <em>Nationality: </em> Egyptian
            </span>
          </div>
          <div className="flex items-center">
            <img
              src={require("../assets/icons/circle.png")}
              alt="circle icon"
              className="w-7 inline-block mr-2"
            />
            <span>
              <em>City: </em> Cairo
            </span>
          </div>
          <div className="flex items-center">
            <img
              src={require("../assets/icons/circle.png")}
              alt="circle icon"
              className="w-7 inline-block mr-2"
            />
            <span>
              <em>Study Status: </em> Graduated
            </span>
          </div>
          <div className="flex items-center">
            <img
              src={require("../assets/icons/circle.png")}
              alt="circle icon"
              className="w-7 inline-block mr-2"
            />
            <span>
              <em>Job Status: </em> Available
            </span>
          </div>
        </div>
      </div>

      {/* WORK EXPERIENCE */}
      <div
        className="mt-24"
        data-aos="fade-right"
        data-aos-easing="ease-in-sine"
        data-aos-duration="400">
        <h1 className="text-3xl my-9">Work Experience</h1>
        <div className="flex justify-between flex-col gap-6">
          <div className="flex items-start flex-col gap-1">
            <p className="flex items-center">
              <img
                src={require("../assets/icons/circle.png")}
                alt="circle icon"
                className="w-7 inline-block mr-2"
              />
              <em>Frontend Developer - Freelancer</em>
            </p>
            <p className="pl-7">- Feb 2021 : Dec 2022</p>
            <p className="pl-7">
              - Deal with Clients and transfer their needs to real websites.
              <br />
              Either build them from scratch or edit what already exists.
            </p>
            <p className="pl-7">- Only work in my free time.</p>
          </div>

          <div className="flex items-start flex-col gap-1 mt-3">
            <p className="flex items-center">
              <img
                src={require("../assets/icons/circle.png")}
                alt="circle icon"
                className="w-7 inline-block mr-2"
              />
              <em>
                Frontend Developer Intern - Zinad IT,{" "}
                <small>Smart Village</small>
              </em>
            </p>
            <p className="pl-7">- Feb 2021 : Dec 2022</p>
            <p className="pl-7">- Communicate with UI/UX & Backend teams. </p>
            <p className="pl-7">- Build responsive landing pages.</p>
            <p className="pl-7">
              - Build emails designs with HTML & CSS and made them fit with
              Outlook & Gmail users
            </p>
          </div>
        </div>
      </div>

      {/* INTEREST */}
      <div
        className="mt-24"
        data-aos="fade-right"
        data-aos-easing="ease-in-sine"
        data-aos-duration="400">
        <h1 className="text-3xl my-9">Interest</h1>
        <div className="flex items-start flex-wrap gap-9">
          <img
            src={require("../assets/icons/color palate.webp")}
            alt=""
            className="w-20"
          />
          <img
            src={require("../assets/icons/books.webp")}
            alt=""
            className="w-20"
          />
          <img
            src={require("../assets/icons/camera.png")}
            alt=""
            className="w-20"
          />
        </div>
      </div>

      {/* FOOTER */}
      <Footer />
    </div>
  );
}

export default About;
